export default __webpack_public_path__ + "static/media/check-clean-icon.1b5289dc.svg";